import React, { FunctionComponent } from "react";
import { IAlbum } from "../../../hooks/albums";
import { Box, Card, ListItemText, Skeleton, Stack, useTheme } from "@mui/material";
import { strings } from "../../../localization/LocalizedStrings";
import styles from "./styles.module.scss";
import { ToolbarButton } from "../../toolbar/ToolbarButton";
import { AlbumLocationTable } from "../location/AlbumLocationTable";
import { RoutesBuilder } from "../../../models/RoutesBuilder";
import { BoxSetListItem } from "../BoxSetListItem";
import { IShelfSegmentAlbum } from "../../../hooks/shelfSegments";
import { productIconMap } from "../../../models/ProductUtilities";
import { ProductType } from "../../../hooks/products/interfaces";
import { PiperDivider } from "../../PiperDivider";

export const AlbumLocationListSection: FunctionComponent<IAlbumLocationListSectionProps> = ({
  album,
  onBoxSetSelected,
  onLocationSelected,
  hideHeader
}) => {
  const theme = useTheme();
  const isLoading = album?.shelfSegments === undefined;
  return (
    <div>
      <div className={styles.tableDiv}>
        {!hideHeader && (
          <Stack className={styles.header} direction={"row"} spacing={2} sx={{ width: "100%" }}>
            <ListItemText
              disableTypography
              className={styles.title}
              secondary={strings.album_location_title}
              sx={{ flexGrow: 0 }}
            />
            <Box flexGrow={1} />
            <ToolbarButton
              tooltip={strings.shortcuts_layout}
              iconType={productIconMap[ProductType.SHELVINGS]}
              loading={isLoading}
              href={`${window.location.protocol}//${window.location.host}${RoutesBuilder.layout()}`}
              target={"_blank"}
            />
          </Stack>
        )}
        {(album && album.shelfSegments && album.shelfSegments.length > 0) ||
        (album && album.isInsideBoxSet && album.boxSet) ? (
          <Card
            sx={{
              width: "100%",
              borderWidth: "1.5px",
              borderColor: theme.palette.background.paper,
              borderStyle: "solid"
            }}
          >
            {album.isInsideBoxSet && album.boxSet && !hideHeader && (
              <>
                <BoxSetListItem boxSet={album.boxSet} onClick={onBoxSetSelected} />
                {album.shelfSegments && album.shelfSegments.length > 0 && (
                  <PiperDivider color={theme.palette.background.paper} />
                )}
              </>
            )}
            {album.shelfSegments && album.shelfSegments.length > 0 && (
              <AlbumLocationTable album={album} onLocationSelected={onLocationSelected} />
            )}
          </Card>
        ) : isLoading ? (
          <Skeleton variant={"rectangular"} className={styles.skeleton} />
        ) : (
          <p className={styles.noLocationText} style={{ color: theme.palette.secondary.main }}>
            {strings.album_no_location}
          </p>
        )}
      </div>
    </div>
  );
};

export interface IAlbumLocationListSectionProps {
  album: IAlbum;
  onBoxSetSelected: () => void;
  onLocationSelected?: (shelfSegmentAlbum: IShelfSegmentAlbum) => void;
  hideHeader?: boolean;
}
